import { Avatar, Box, Grid, IconButton, Typography } from '@mui/material';
import { BLUE_GRAY_50, BLUE_GRAY_500, GRAY_200 } from '../../constants/Colors';
import { Edit } from '@mui/icons-material';
import { useState } from 'react';
import { Upload } from '../buttons/BakeasyButtons';
import { useAppDispatch, useAppSelector } from '../../redux_store/reduxStore';
import { uploadProfileImage } from '../../redux_store/slices/ProfileUpdateSlice';
import { getProfile, getProfileState } from '../../redux_store/slices/GetUserProfileSlice';

export interface BakeasyAvatarProps {
  value?: string;
  height?: number;
  width?: number;
  isEdit?: boolean | false;
  selectedImage?: any;
}

function stringAvatar(props: BakeasyAvatarProps) {
  let tempName = props?.value?.trim() ?? '';
  if (tempName.split(' ').length > 1) {
    tempName = `${tempName.split(' ')[0][0]}${tempName.split(' ')[1][0]}`;
  } else {
    tempName = `${tempName.charAt(0)}${tempName.charAt(1)}`;
  }

  return {
    sx: { bgcolor: BLUE_GRAY_500, width: props?.width ?? 90, height: props?.height ?? 90 },
    children: (
      <Typography sx={{ fontSize: props?.width ? props?.width / 2 : 22 }}>{tempName}</Typography>
    )
  };
}

export function BakeasyAvatar(props: BakeasyAvatarProps) {
  const dispatch = useAppDispatch();
  const [selectedImage, setSelectedImage] = useState<any>(null);
  const [selectedImageFile, setSelectedImageFile] = useState<any>(null);

  let _userProfile: any = useAppSelector(getProfileState);

  let tempName = props?.value?.trim() ?? '';
  if (tempName.split(' ').length > 1) {
    tempName = `${tempName.split(' ')[0][0]}${tempName.split(' ')[1][0]}`;
  } else {
    tempName = `${tempName.charAt(0)}${tempName.charAt(1)}`;
  }

  const handleImageChange = (event: any) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedImageFile(file);

      const reader = new FileReader();
      reader.onloadend = () => {
        setSelectedImage(reader?.result);
      };
      reader.readAsDataURL(file);
    }
  };

  async function uploadImage() {
    const formData = new FormData();
    formData.append('file', selectedImageFile);
    formData.append('type', 'adminProfileImage');
    let response: any = await dispatch(uploadProfileImage(formData));
    if (response?.payload?.status === 200) {
      setSelectedImage(null);
      setSelectedImageFile(null);
      await dispatch(getProfile(''));
    }
  }

  if (props?.isEdit) {
    return (
      <Box
        position="relative"
        display="flex"
        sx={{ flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}
      >
        <Avatar
          alt="Profile Picture"
          sx={{ width: 90, height: 90, backgroundColor: BLUE_GRAY_500 }}
        >
          {selectedImage ? (
            <img src={selectedImage} style={{ width: 75, height: 75, objectFit: 'scale-down' }} />
          ) : _userProfile?.value?.filePath ? (
            <img
              src={_userProfile?.value?.filePath}
              style={{ width: 75, height: 75, objectFit: 'scale-down' }}
            />
          ) : (
            <Typography sx={{ fontSize: '2rem' }}>{tempName}</Typography>
          )}
        </Avatar>

        <IconButton
          component="label"
          sx={{
            position: 'absolute',
            top: 0,
            right: 0,
            bgcolor: GRAY_200,
            opacity: 1,
            boxShadow: 1,
            padding: 0.5,
            '&:hover': { bgcolor: BLUE_GRAY_50 }
          }}
        >
          <Edit fontSize="small" />
          <input type="file" hidden accept="image/*" onChange={handleImageChange} />
        </IconButton>
        {selectedImage && (
          <Grid sx={{ marginTop: 1 }}>
            <Upload
              onClick={() => {
                uploadImage();
              }}
            />
          </Grid>
        )}
      </Box>
    );
  } else {
    if (_userProfile?.value?.filePath) {
      return (
        <Avatar
          alt="Profile Picture"
          sx={{ width: 24, height: 24, backgroundColor: BLUE_GRAY_500 }}
        >
          <img
            src={_userProfile?.value?.filePath}
            style={{ width: 21, height: 21, objectFit: 'scale-down' }}
          />
        </Avatar>
      );
    } else {
      return <Avatar {...stringAvatar(props)} />;
    }
  }
}
